import { hillo } from 'hillo'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import GlobalConfig from '@/model/global/GlobalSettings'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import dayjs from 'dayjs'
import { ageDisplay } from '@/model/dataLayer/api/Vip/UserDetail'
import { getAllUser } from '@/model/dataLayer/api/MembershipSystem/UserMembership'

const entity = {
  username: {
    displayName: '用户名'
  },
  ageDisplay: {
    displayName: '年龄段',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => { return await getAllUser() },
        itemText: 'ageDisplay',
        itemValue: 'ageDisplay'
      }
    },
    form: false
  },
  gender: {
    displayName: '性别',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => { return await getAllUser() },
        itemText: 'gender',
        itemValue: 'gender'
      }
    },
    form: false
  },
  userLastConsumeAt: {
    type: IKDataEntity.Types.Date,
    formConfig: {
      type: {
        operation: 'date',
        needFilter: true
      }
    },
    displayName: '上次消费时间'
  },
  userTotalConsume: {
    type: IKDataEntity.Types.String,
    formConfig: {
      type: {
        name: 'text',
        operation: '>=',
        needFilter: true,
        hint: '筛选大于或等于输入值的'
      }
    },
    displayName: '最高消费'
  },
  currentPoints: {
    type: IKDataEntity.Types.String,
    formConfig: {
      type: {
        name: 'text',
        operation: '>=',
        hint: '筛选大于或等于输入值的',
        needFilter: true
      }
    },
    displayName: '积分'
  }
}

const config = {
  load: async function (filter) {
    const res = (await hillo.get(cloudV2Url + 'membership/user/business-layers/' + GlobalConfig.blId + '/members')).map(it => {
      it.password = it.cloudUserInfo.password
      it.username = it.cloudUserInfo.username
      it.email = it.cloudUserInfo.email
      it.refUserId = it.cloudUserInfo.refUserId
      it.phoneNumber = it.cloudUserInfo.phoneNumber
      it.otp = it.cloudUserInfo.otp
      it.otpGeneratedAt = it.cloudUserInfo.otpGeneratedAt
      it.enabled = it.cloudUserInfo.enabled
      it.accountNonLocked = it.cloudUserInfo.accountNonLocked
      it.accountLockedAt = it.cloudUserInfo.accountLockedAt
      it.createTimestamp = it.cloudUserInfo.createTimestamp
      it.lastLoginAt = it.cloudUserInfo.lastLoginAt
      it.ageDisplay = ageDisplay(it.cloudUserInfo.birthday)
      it.gender = it.cloudUserInfo.gender
      it.userLastConsumeAt = it.currentMembership.userLastConsumeAt ? dayjs(it.currentMembership.userLastConsumeAt).format('YYYY-MM-DD HH:mm:ss') : '-'
      it.userTotalConsume = it.currentMembership.userTotalConsume
      it.currentPoints = it.currentMembership.currentPoints
      return it
    })
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)
